<template>
    <!--Slider start-->
    <section class="slide-bg" id="home">
         <div class="animation-circle-inverse">
                <i></i>
                <i></i>
                <i></i>
            </div>
     <b-modal 
     header-bg-variant="warning"
     header-text-variant="dark"
     id="modal-scrollable" scrollable title="ลงทะเบียน">
    <p class="my-4" >
     egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
    </p>
  </b-modal>
        <div class="container">
           <!--  <div class="row">
                <div class="col-md-6">
                    <div class="d-flex-1">
                        <div class="slide-text">
                            <div>
                                <h1>The best way to connect with your friends is with
                                    <span class="main-title">ChatLoop!</span>
                                </h1>
                                <h4>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </h4>
                                <div class="slid-btn">
                                    <a href="#"><img :src='"../assets/images/app1.png"' alt="app1" class="img-fluid" data-tilt data-tilt-perspective="50" data-tilt-speed="350" data-tilt-max="1.8"></a>
                                    <a href="#"><img :src='"../assets/images/app2.png"' alt="app2" class="img-fluid" data-tilt data-tilt-perspective="50" data-tilt-speed="350" data-tilt-max="1.8"></a>
                                    <a href="#"><img :src='"../assets/images/app2.png"' alt="app2" class="img-fluid" data-tilt data-tilt-perspective="50" data-tilt-speed="350" data-tilt-max="1.8"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="home-right">
                        <div class="mobile-slid">
                            <img :src='"../assets/images/top-mobile.png"' alt="top1" class="img-fluid">
                        </div>
                        <div class="profile-msg">
                            <img :src='"../assets/images/top2.png"' alt="top2" class="img-fluid" >
                        </div>
                        <div class="awesome">
                            <img :src='"../assets/images/top3.png"' alt="top3" class="img-fluid">
                        </div>
                        <div class="profile-1">
                            <img :src='"../assets/images/top4.png"' alt="top4" class="img-fluid">
                        </div>
                        <div class="emoji">
                            <img :src='"../assets/images/top5.png"' alt="top5" class="img-fluid">
                        </div>
                        <div class="profile-2">
                            <img :src='"../assets/images/top1.png"' alt="top1" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="profile-2">
                            <img :src='"../assets/images/top1.png"' alt="top1" class="img-fluid">
                        </div>
                         <div class="awesome">
                            <img :src='"../assets/images/top3.png"' alt="top3" class="img-fluid">
                        </div>
            <div class="row">
                <div class="col-md-12">
                    
                    <div >
                       
                    
                      
                        <div class="slide-text">
                            <div class="text-right">
                                 <h1 class="text-head-green" >วันสถาปนาการยางแห่งประเทศไทย 2564
                                 </h1>
                                 <h1 class="text-head-sub-green">ครบรอบ 6 ปี กยท. ก้าวไกลยุคดิจิทัล</h1>   

                            </div>
                            <div>
                               
                                <div class="slid-btn-pic text-right mr-5" >
                                 <router-link to="/Exhibition">   <img :src='"../assets/images/pic_intro.png"' alt="app1" class="img-fluid" data-tilt data-tilt-perspective="50" data-tilt-speed="350" data-tilt-max="1.8"></router-link>
                                   
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div >
                        <div class="slide-text2">
                            <div class="text-center">
                             
                                
                                <div class="slid-btn">
                                  <router-link to="/Greeting">  <img  :src='"../assets/images/menu1.png"' alt="app1" class="img-fluid" data-tilt data-tilt-perspective="50" data-tilt-speed="350" data-tilt-max="1.8" ></router-link>
                                    
                                </div>
                                <div class="slid-btn2">
                                 
                                    <router-link to="/Exhibition"><img :src='"../assets/images/menu2.png"' alt="app1" class="img-fluid" data-tilt data-tilt-perspective="50" data-tilt-speed="350" data-tilt-max="1.8" style=" margin-right: 30px;"></router-link>
                                    <a href="http://raot.co.th/main.php?filename=index" target="_blank"><img :src='"../assets/images/menu3.png"' alt="app2" class="img-fluid" data-tilt data-tilt-perspective="50" data-tilt-speed="350" data-tilt-max="1.8" ></a>
                                </div>
                                <h3 class="text-green text-center m-6" >Moving forward to Digital Organization </h3>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            
        </div>
    </section>
    <!--Slider end -->
</template>
<script>
export default {
  name: 'Slider'
}
</script>
